<template>
  <div class="b-card-container flex-1">
    <div class="bc-header-container">
      <div class="bc-header">
        Hub Detail
      </div>
      <div class="bc-header">
        Total: {{ hubs.length }}
      </div>
    </div>
    <div class="hub-details-container">
      <div class="hub-table-headers sac__font-14 n70 semi-bold">
        <div>Serial Number</div>
        <div>Date Activated</div>
        <div>Status</div>
        <div>In Home Location</div>
        <div>Connection</div>
        <div>Installed Address</div>
        <div />
      </div>
      <div class="hub-table-data sac__font-14">
        <div v-for="(d, idx) in hubs" :key="idx" class="hub-table-rows">
          <div class="bi-body">
            <router-link v-if="isSmacAdmin" :to="`/device/${d.uId}`">
              {{ d.uId }}
            </router-link>
            <span v-else>
              {{ d.uId }}
            </span>
            <button
              type="button"
              @click="copyUid(d.uId)"
            >
              <i class="icon-Clipboard ml-1" />
            </button>
          </div>
          <div>{{ dateAndYear(d.creationDate) }}</div>
          <div class="grid-column ai-c gap-10">
            <div
              :class="[
                determineDeviceStatus(d.status),
                'bi-body',
              ]"
            >
              {{ deviceStatus(d.status) }}
            </div>
            <div v-if="adminRole !== 'viewer'">
              <img
                v-if="d.isVerified"
                class="img-size-20"
                src="@shared/assets/img/general/verified-badge.svg"
                alt="verified"
              />
              <button
                v-else
                type="button"
                @click="toggleActionModal(true, 'unverified-reasons', d)"
              >
                <img class="img-size-20" src="@shared/assets/img/general/not-verified-badge.svg" alt="verified" />
              </button>
            </div>
          </div>
          <div>{{ hvac[idx]?.systemName }}</div>
          <div>{{ d.connectMethod }}</div>
          <div class="grid-column jc-c gap-10">
            <div>
              <span>
                {{ hubAddress(d.serviceAddressId)?.address1 }}
                {{ hubAddress(d.serviceAddressId)?.address2 }}
                {{ hubAddress(d.serviceAddressId)?.city }},
                {{ hubAddress(d.serviceAddressId)?.state }}
                {{ hubAddress(d.serviceAddressId)?.zip }}
              </span>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    x-small
                    v-on="on"
                    @click.stop.prevent="navigateToZillow(d.serviceAddressId)"
                  >
                    mdi-share
                  </v-icon>
                </template>
                <span>See Address</span>
              </v-tooltip>
            </div>
          </div>
          <div v-if="adminRole !== 'viewer'" class="hub-row-edit-2">
            <button
              type="button"
              class="edit-btn"
              @click="toggleActionModal(true, 'edit-hub', d, hvac[idx])"
            >
              <img src="@shared/assets/img/general/edit.svg" class="img-size-20" alt="edit">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'HubDetail',
  mixins: [customerDetailMixin, unitPreferencesMixin],
  methods: {
    hubAddress(addressId) {
      return this.customer.serviceAddress.find((add) => add.id === addressId);
    },
    copyUid(uid) {
      window.navigator.clipboard.writeText(uid);

      this.$store.dispatch('showSuccessToast', {
        message: `${uid} copied.`,
      });
    },
    navigateToZillow(addressId) {
      const address = this.hubAddress(addressId);
      const {
        address1,
        city,
        state,
        zip,
      } = address;

      const add1 = address1.split(' ').join('-');

      const zillowUrl = `https://www.zillow.com/homes/${add1},-${city},-${state},-${zip}_rb`;
      window.open(
        zillowUrl,
        '_blank',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.hub-details-container {
  padding: 10px;
  background-color: $WHITE;
  max-height: 300px;

  .hub-table-headers {
    grid-template-columns: 2fr 1.5fr 2fr 1.5fr 1fr 2fr 1fr;
    display: grid;
    width: 100%;
    padding: 8px 0;
    gap: 1rem;
    border-bottom: 2px solid $N5;
    white-space: nowrap;
    justify-items: center;

  }

  .hub-table-data {
    max-height: 190px;
    overflow: auto;

    .hub-table-rows {
      grid-template-columns: 2fr 1.5fr 2fr 1.5fr 1fr 2fr 1fr;
      display: grid;
      width: 100%;
      padding: 10px;
      gap: 1rem;
      justify-items: center;

      &:nth-child(even) {
        background-color: $NBLUE5;
      }

      .hub-row-edit-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-items: flex-end;

        .hub-row-edit {
          border: 1px solid $N100;
          width: 50px;
          height: 25px;
          text-align: center;
          border-radius: 6px;
          color: $BLACK;
          font-size: 14px;

          &:hover {
            background-color: $N100;
            color: $WHITE;
          }
        }
      }

    }
  }

  .verification-container {
    position: relative;
    cursor: pointer;
  }
}
</style>
